module.exports = fox._r("fonts/woodfordbourne-italic-webfont.svg", __webpack_public_path__ + "fonts/woodfordbourne-italic-webfont.svg");


//////////////////
// WEBPACK FOOTER
// ./fonts/woodfordbourne-italic-webfont.svg
// module id = 8
// module chunks = 5